import pcURL from '@planningcenter/url';
import { useState, useCallback, useEffect } from 'react';
import apiRequest, { railsCsrfFetch } from '../../chat-core/api_request.js';
import { useChatApi } from './use_chat_api.js';

const useTotalUnreadCount = ({ client, currentPersonId, isChannelListViewActive, env, }) => {
    const [markAllReadProcessing, setMarkAllReadProcessing] = useState(false);
    const [totalUnreadCount, setTotalUnreadCount] = useState(() => client.user.unread_count);
    const api = useChatApi();
    const refreshTotalUnreadCount = async () => {
        api.chat
            .get(`me/stream_user`, {
            context: "default",
            fields: { StreamUser: "unread_count" },
        })
            .then(({ unread_count }) => setTotalUnreadCount(unread_count));
    };
    const updateStreamUser = async () => await api.chat.post("me/stream_user_updated", {});
    const bulkUpdateChatNotifications = useCallback(async (currentPersonId) => {
        const url = `${pcURL(env)("api")}/notifications/v2/me/bulk_update`;
        const body = {
            data: {
                attributes: {
                    partition: "chat",
                },
                relationships: {
                    rollup_keys: {
                        data: {
                            source: "/included/person/*",
                        },
                    },
                },
                type: "BulkUpdate",
            },
            included: [
                {
                    attributes: { action: "read" },
                    id: `${currentPersonId}`,
                    type: "person",
                },
            ],
        };
        return await apiRequest(railsCsrfFetch, url, {
            data: body,
            method: "POST",
        });
    }, [currentPersonId]);
    const markAllRead = async () => {
        setMarkAllReadProcessing(true);
        await client.markAllRead();
        await bulkUpdateChatNotifications(currentPersonId);
        await updateStreamUser();
        await refreshTotalUnreadCount();
        setMarkAllReadProcessing(false);
    };
    useEffect(() => {
        isChannelListViewActive && refreshTotalUnreadCount();
    }, [isChannelListViewActive]);
    return {
        markAllRead,
        markAllReadProcessing,
        refreshTotalUnreadCount,
        totalUnreadCount,
    };
};

export { useTotalUnreadCount };
//# sourceMappingURL=use_total_unread_count.js.map
